// src/pages/AdminPage/utils/adminTypes.ts

// ─── USER ──────────────────────────────────────────────────────────
export interface UserSummary {
  totalSessions: number;
  completedSessions: number;
  totalAnswered: number;
  totalCorrect: number;
  totalWrong: number;
  avgScore: number;
  favoritesCount: number;
}

export interface UserItem {
  id: string;
  name: string;
  email: string | null;
  phone_number: string | null;
  telegram_username: string | null;
  telegram_photo_url: string | null;
  role: "USER" | "ADMIN";
  auth_provider: "local" | "google" | "telegram";
  is_active: boolean;
  created_at: string;
  updated_at: string;
  summary: UserSummary;
}

// ─── PAGINATION ────────────────────────────────────────────────────
export interface PaginationMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface PaginatedResponse<T> {
  data: T[];
  meta: PaginationMeta;
}

// ─── QUESTION ──────────────────────────────────────────────────────
export enum QuestionType {
  ODDIY = "oddiy",
  SONLI = "sonli",
  KALIT_SOZLI = "kalit_sozli",
  MURAKKAB = "murakkab",
}

export interface QuestionItem {
  id: number;
  question_oz?: string;
  question_uz?: string;
  question_ru?: string;
  correct_answer_index: number;
  photo_url?: string;
  ticket_id?: number;
  topic_id?: number;
  topic?: { id: number; name_oz: string; name_uz: string };
  question_type?: QuestionType;
  keywords?: string[];
  created_at?: string;
}

// ─── TOPIC ─────────────────────────────────────────────────────────
export interface TopicItem {
  id: number;
  name_oz: string;
  name_uz: string;
  name_ru: string;
  description_oz?: string;
  description_uz?: string;
  description_ru?: string;
  question_count?: number;
  created_at?: string;
}

// ─── DASHBOARD STATS ───────────────────────────────────────────────
export interface DashStats {
  totalUsers: number;
  premiumUsers: number;
  totalQuestions: number;
  totalTickets: number;
  totalTopics: number;
  todayUsers: number;
  weekUsers: number;
  monthUsers: number;
}

export interface DayStats {
  date: string;
  count: number;
}

// ─── NOTIFICATION ──────────────────────────────────────────────────
export interface NotificationItem {
  id: number;
  title: string;
  text: string;
  image_url: string | null;
  createdAt: string;
  updatedAt: string;
}

// ─── VIDEO ─────────────────────────────────────────────────────────
export interface VideoItem {
  id: number;
  title: string;
  description?: string | null;
  video_url: string | null;
  thumbnail_url: string | null;
  order_index: number;
  createdAt: string;
  updatedAt: string;
}

// ─── QUESTION REPORT ───────────────────────────────────────────────
export type QuestionReportType = "wrong_answer" | "typo" | "comment";
export type QuestionReportStatus = "pending" | "reviewed" | "resolved";

export interface QuestionReportItem {
  id: number;
  types: QuestionReportType[];
  comment: string | null;
  status: QuestionReportStatus;
  createdAt: string;
  updatedAt: string;
  user: {
    id: string;
    name?: string;
    phone_number?: string | null;
    telegram_username?: string | null;
  };
  question: {
    id: number;
    question_uz?: string;
    ticket?: { id: number; bob: number };
  };
}

// ─── TAB & TOAST ───────────────────────────────────────────────────
export type AdminTab =
  | "dashboard"
  | "users"
  | "questions"
  | "topics"
  | "notifications"
  | "videos"
  | "reports";

export interface ToastState {
  msg: string;
  type: "success" | "error";
}

// src/pages/AdminPage/utils/adminTypes.ts ga qo'sh:

export interface AdminTicketListItem {
  id: number;
  bob: number;
  count: number;
}

export interface AdminTicketQuestionsResponse {
  ticket: AdminTicketListItem;
  data: AdminQuestionResponse[];
  total: number;
}
export interface AdminQuestionChoice {
  id: number;
  order_index: number;
  text_uz: string;
  text_oz: string;
  text_ru: string;
}
export interface AdminQuestionResponse {
  id: number;
  question_uz: string;
  question_oz: string;
  question_ru: string;
  correct_answer_index: number;
  photo_url: string | null;
  audio_oz_url?: string | null;
  audio_uz_url?: string | null;
  audio_ru_url?: string | null;
  explanation_uz?: string;
  explanation_oz?: string;
  explanation_ru?: string;
  ticketId?: number;
  topicId?: number;
  question_type?: QuestionType;
  keywords?: string[];
  mistake_count?: number;
  choices: AdminQuestionChoice[];
}
